/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Subtitle_File_TitleInputs */

const en_file_export_subtitle_file_title = /** @type {(inputs: File_Export_Subtitle_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitle File`)
};

const fr_file_export_subtitle_file_title = /** @type {(inputs: File_Export_Subtitle_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fichier de sous-titres`)
};

const de_file_export_subtitle_file_title = /** @type {(inputs: File_Export_Subtitle_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertiteldatei`)
};

const it_file_export_subtitle_file_title = /** @type {(inputs: File_Export_Subtitle_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File dei sottotitoli`)
};

const ru_file_export_subtitle_file_title = /** @type {(inputs: File_Export_Subtitle_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Файл субтитров`)
};

const es_file_export_subtitle_file_title = /** @type {(inputs: File_Export_Subtitle_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivo de subtítulos`)
};

const zh_cn2_file_export_subtitle_file_title = /** @type {(inputs: File_Export_Subtitle_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕文件`)
};

const ja_file_export_subtitle_file_title = /** @type {(inputs: File_Export_Subtitle_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕ファイル`)
};

const hi_file_export_subtitle_file_title = /** @type {(inputs: File_Export_Subtitle_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक फ़ाइल`)
};

const pt_pt2_file_export_subtitle_file_title = /** @type {(inputs: File_Export_Subtitle_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivo de legenda`)
};

/**
* | output |
* | --- |
* | "Subtitle File" |
*
* @param {File_Export_Subtitle_File_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_subtitle_file_title = /** @type {((inputs?: File_Export_Subtitle_File_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Subtitle_File_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_subtitle_file_title(inputs)
	if (locale === "de") return de_file_export_subtitle_file_title(inputs)
	if (locale === "it") return it_file_export_subtitle_file_title(inputs)
	if (locale === "ru") return ru_file_export_subtitle_file_title(inputs)
	if (locale === "es") return es_file_export_subtitle_file_title(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_subtitle_file_title(inputs)
	if (locale === "ja") return ja_file_export_subtitle_file_title(inputs)
	if (locale === "hi") return hi_file_export_subtitle_file_title(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_subtitle_file_title(inputs)
	return en_file_export_subtitle_file_title(inputs)
});